import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.dynamicClasses},[_c('div',{staticClass:"wrapDetails"},[_c(VIcon,{attrs:{"color":_vm.iconSettings.color}},[_vm._v(_vm._s(_vm.iconSettings.icon))]),_c('div',{staticClass:"errorDetail"},[_c('p',[_c('span',[_vm._v(" "+_vm._s(_vm.certificateWarning)+" ")])])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }